import React from 'react';
import { Link } from 'react-router-dom';

import Button from 'ui/Button';

import { Path } from '../../utils/routes';

const TryDemoDiagramButton: React.FC = () => (
  <Link to={Path.SankeyMainExample}>
    <Button variant="primary-solid" w="280px">
      Try our demo diagram
    </Button>
  </Link>
);

export default TryDemoDiagramButton;
